import { render, staticRenderFns } from "./CamImage.vue?vue&type=template&id=08083993&"
import script from "./CamImage.vue?vue&type=script&lang=ts&"
export * from "./CamImage.vue?vue&type=script&lang=ts&"
import style0 from "./CamImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports